const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocNormal(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18 33.348a.939.939 0 0 0-.045-.223.971.971 0 0 0-.123-.2.882.882 0 0 0-.074-.12l-8.238-8.781-.013-.009a1.015 1.015 0 0 0-.208-.147 1.051 1.051 0 0 0-.112-.076 1.133 1.133 0 0 0-.145-.033 1.008 1.008 0 0 0-.236-.047h-11.778a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V33.49a.988.988 0 0 0-.028-.142zm-8.21-6.112 4.911 5.235-4.911-.04zm6.238 20.472h-18v-22h9.762v7.714a1 1 0 0 0 .992 1l7.246.06z",
    transform: "translate(-415.208 -18.708)",
    style: {
      fill: "current"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocNormal);
export default __webpack_public_path__ + "static/media/icon-doc-normal.dfcec5aae5b3d4249527fabd804be44b.svg";
export { ForwardRef as ReactComponent };